/* eslint-disable */

import {VisitSignaturesEnum} from "app/core/enum/visit-signatures";

/* eslint-disable */
export const VisitSignatures = [
    {
        oid: "00000001-0000-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitSignaturesEnum.CRC,
        tooltip: "CRC - Clinic Research Coordinator",
        name: VisitSignaturesEnum.CRC,
        code: "CRC",
        role: "crc",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-slate-400",
        bgClass: "bg-slate-400",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#a1a1a1",
    },
    {
        oid: "00000001-0001-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitSignaturesEnum.SUBI,
        tooltip: "Sub-I - Sub-Investigator",
        name: VisitSignaturesEnum.SUBI,
        code: "SubI",
        role: "SubI",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-slate-400",
        bgClass: "bg-slate-400",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#0069a8",
    },
    {
        oid: "00000002-0002-0000-0000-000000000000",
        sort: 2,
        visit_status: VisitSignaturesEnum.PI,
        old: "missed",
        tooltip: "PI - Principal Investigator",
        name: VisitSignaturesEnum.PI,
        code: "pi",
        role: "pi",
        icon: "davesa:visit-unconfirmed",
        icon2: "davesa:v-unconfirmed",
        icon3: "mat_solid:check",
        textClass: "text-slate-400",
        bgClass: "bg-slate-400",
        textClassContrast: "text-slate-100",
        bgClassContrast: "bg-slate-100",
        bgColor: "#9f2d00",
    },
];
